<template>
  <div class="index">
    <div style="margin-bottom: 10px">
      <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>菜单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

        <el-card>
            <el-button @click="save"  type="primary">配置</el-button>
        </el-card>
        <el-card>

            <el-row  v-for="(item,index) in menu_role_list" :key="index">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="grid-content bg-purple" style="padding-left: 5px;padding-top: 10px">

                        <div style="float:left;padding-top: 3px">
                            <el-checkbox-group v-model="checked_list_data">
                        <el-checkbox :label="parseInt(item.id)" @change="handleCheckAllChange($event,item.id)">{{" "}} </el-checkbox>
                        </el-checkbox-group>
                        </div>

                        <span>{{item.title}}</span>
                    </div>
                    <el-row>

                        <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1" v-for="(item1,index1) in item.children" :key="index1" :gutter="10" style="height: 45px;padding-top: 10px">

                            <div style="float:left;padding-left: 5px;padding-top: 5px">
                                <el-checkbox-group v-model="checked_list_data">
                            <el-checkbox :label="parseInt(item1.id)" :key="item1.id" @change="handleCheckItemChange($event,item1.id,item.id)" >{{''}}</el-checkbox>
                            </el-checkbox-group>
                            </div>
                        <span>{{item1.title}}</span>
                        </el-col>
                    </el-row>

                </el-col>



            </el-row>


        </el-card>



  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
        menu_role_list:[],
        checked_list:{},
        checked_list_data:[],
        roles_id:"",




    };
  },
  methods: {
    ...mapActions({
        getRolesMenuIndexAction: "getRolesMenuIndexAction",
        addRolesMenuAction:"addRolesMenuAction"
    }),
      handleCheckItemChange(val,id,pid){


          if(val){
              this.checked_list_data=Array.from(new Set([...this.checked_list_data,parseInt(pid)]))
          }



          //是否删除主配置
          let check_list=this.checked_list[pid]

          let flag=true

          for(let i in check_list){

              if(this.checked_list_data.includes(check_list[i])){

                  flag=false
                  break

              }

          }

          if(flag){

              let n=this.checked_list_data.indexOf(parseInt(pid))

              if(n!=-1){
                  this.checked_list_data.splice(n, 1);
              }

          }


      },
      handleCheckAllChange(val,id) {


          let  checked_list= this.checked_list[id]


          if(val){


              this.checked_list_data=Array.from(new Set([...this.checked_list_data,...checked_list]))

          }else{
              // let n=this.checked_list_data.indexOf(id)
              // alert(id)
              // this.checked_list_data.splice(n, 1);
              for(let i in checked_list){
                  if(this.checked_list_data.includes(checked_list[i])){

                      let ii=this.checked_list_data.indexOf(checked_list[i])
                      this.checked_list_data.splice(ii, 1);
                  }


              }


          }
      },
    save() {
        if(this.checked_list_data.length>0){
            this.addRolesMenuAction({
                permissions: JSON.stringify(this.checked_list_data),
                roles_id:this.roles_id
            });
        }else{
            this.$message('请选择配置项目');
        }

    },
  },
  mounted() {
      this.roles_id=this.$route.params.id

      this.getRolesMenuIndexAction({roles_id:this.roles_id})
  },
    computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      menu_result: (state) => state.roles_menu.result,
    }),
  },
  watch: {
      menu_result(val) {
         if(val.code==302){

             let items=[]
             let checked_list={}
             for(let k in val.data){
                 items.push(val.data[k])

                 let child=[]
                 for (let kk in val.data[k]['children']){
                     child.push(val.data[k]['children'][kk]['id'])
                     checked_list[val.data[k]['id']]=child
                 }
             }
             this.menu_role_list=items
             this.checked_list= checked_list
             this.checked_list_data=JSON.parse(val.roles_menu)
         }
         if(val.code==301){
             this.$message(
                 {
                     message: "配置成功",
                     type: 'success'
                 }
                 )
         }

    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>
